const UserHelp = () => import('@/pages/help/UserHelp');

// const help =
// { 
//   path: 'help',
//   name: 'UserHelp',
//   component: UserHelp     
// };


export default {
    component: UserHelp,
    name: 'UserHelp',
    path: '/help',
    //redirect: '/',
    // children: [
    //   { path: '' },
    //   { path: '' },
    //   { path: '' }
    // ]
  }
  